/**
 * BaseStore - Abstract class to standardize store access for core classes
 * Provides a typed state getter that proxies to store.getState().
 */

export type ReadonlyZustandStore<TState> = {
  getState: () => TState;
};

export abstract class BaseStore<TState extends object> {
  protected readonly store: ReadonlyZustandStore<TState>;

  protected constructor(storeOrState: ReadonlyZustandStore<TState> | TState) {
    if (storeOrState && typeof (storeOrState as any).getState === "function") {
      this.store = storeOrState as ReadonlyZustandStore<TState>;
    } else {
      // Wrap plain object to behave like a store for read-only access
      const snapshot = storeOrState as TState;
      this.store = {
        getState: () => snapshot,
      };
    }
  }

  // Always returns the latest store snapshot
  get state(): TState {
    return this.store.getState();
  }
}
